import React from "react";
import "./Tools.css";
import {
    SiVercel,
    SiNetlify,
    SiNpm,
    SiPostman,
    SiRedis,

} from "react-icons/si";
import { VscGithub } from "react-icons/vsc";

export const Tools = () => {
    return (
        <>
            <div className="section main" data-aos="fade-right">
                <h2 className="section__title different" style={{ padding: "20px" }} >Tools</h2>
                <div className="tools">
                    <div>
                        <SiNpm />
                        <h5>Npm</h5>
                    </div>
                    <div>
                        <SiNetlify />
                        <h5>Netlify</h5>
                    </div>
                    <div>
                        < SiVercel />
                        <h5>Vercel</h5>
                    </div>
                    <div>
                        <VscGithub />
                        <h5>Github</h5>
                    </div>
                    <div>
                        <SiPostman />
                        <h5>PostMan</h5>
                    </div>
                    <div>
                        <SiRedis />
                        <h5>Redis</h5>
                    </div>
                </div>
            </div>
        </>
    );
};
